module.exports = __webpack_public_path__ + "img/pfeil_rechts_white.b1335d43.svg";